import { Group, useMantineTheme } from "@mantine/core";
import { CircleFilledIcon, DataGridPage, DataGridPageProps, GridColumnsOverrides } from "@mcurros2/microm";
import { IconCheck, IconMapPinFilled, IconSquareXFilled } from "@tabler/icons-react";
import { useMemo } from "react";

export interface TiendasPageProps extends DataGridPageProps {

}

export function TiendasPage(props: TiendasPageProps) {
    const { } = props;

    const theme = useMantineTheme();

    const configuracion = useMemo<GridColumnsOverrides>(() => ({
        // Domicilio geolocalizado
        5: { render: (value: unknown) => (!value) ? <Group><IconMapPinFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin ubicación</Group> : value },
        // Tienda activa
        8: {
            render: (value: unknown) => (value === 'ACTIVO') ?
                <Group style={{ gap: '0rem' }}><CircleFilledIcon mr="xs" width="1.3rem" icon={<IconCheck size="0.9rem" />} />Activa</Group>
                : <Group style={{ gap: '.5rem' }}><IconSquareXFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Baja</Group>
        },
    }), []);

    return (
        <DataGridPage
            {...props}
            columnsOverrides={configuracion}
        />
    );
}